import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import Navbar from './common/Navbar';

import * as selector from '../selectors';

const mapStateToProps = state => {
	return {
		settings: selector.getSettings(state),
	};
};

@connect(mapStateToProps)
export default class extends Component {
	static propTypes = {
		settings: PropTypes.object,
	}

	render() {
		const {
			settings: {
				plan,
			},
		} = this.props;

		return (
			<div className="content">
				<Navbar />
				<div className="plan">
					{plan && (
						<img src={plan} alt="" className="img-fluid" />
					)}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Plan.js